// Import model
import { InstallationTypeOptionCondition } from '../models/InstallationTypeOptionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { InstallationTypeOptionIndexedFields } from '../models/InstallationTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { InstallationTypeOptionIndexedFieldsSerializer } from './InstallationTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for InstallationTypeOptionCondition - handles JSON serialization and deserialization with type validation
 */
export class InstallationTypeOptionConditionSerializer {
  /**
   * Deserializes a JSON string into a InstallationTypeOptionCondition instance
   */
  static deserialize(json: string): InstallationTypeOptionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a InstallationTypeOptionCondition instance
   */
  static fromObject(obj: any): InstallationTypeOptionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to InstallationTypeOptionCondition');
    }


    const instance: InstallationTypeOptionCondition = {
      fieldName: obj['fieldName'] as InstallationTypeOptionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of InstallationTypeOptionCondition instances
   */
  static deserializeArray(json: string): InstallationTypeOptionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a InstallationTypeOptionCondition instance to a JSON string
   */
  static serialize(instance: InstallationTypeOptionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a InstallationTypeOptionCondition instance to a plain object
   */
  static toObject(instance: InstallationTypeOptionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of InstallationTypeOptionCondition instances to a JSON string
   */
  static serializeArray(instances: InstallationTypeOptionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
